/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="../../components/baseclasses/guid.ts" />
/// <reference path="../../components/models/meevo.model.custom.ts" />

module Meevo.Plugins.ProductCategories {
  "use strict";

  export class ProductCategoriesContext extends Meevo.Components.BaseClasses.DataMaintenanceContextBase {    

    constructor(appSettings: Meevo.Components.Common.IAppSettings,
      dataService: Meevo.Components.BaseClasses.IDataService,
      modalService: Meevo.Components.Modal.IModalService,
      identityService: Meevo.Components.Common.IIdentityService,
      loggingService: Meevo.Components.Logging.ILoggingService,
      securityChecker: Meevo.Components.Common.ISecurityService,
      trackingService: Meevo.Components.Tracking.ITrackingService) {

      super(appSettings, dataService, modalService, identityService, loggingService, securityChecker, trackingService);

      this.baseEndpoint = appSettings.API_ENDPOINTS.productcategories;
      this.sectionTemplatePath = "app/plugins/productCategories/sectionViews/";

      this.buildCrudSecurityKeys(this.securityKeys.DATA_PRODUCTCATEGORY_TAB_MAIN);
      this.entityType = 'ProductCategory';

    }

    initializeSections(): void {
        if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.DATA_PRODUCTCATEGORY_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ))
            this.sections.push(new MainSection(0, "SECTION_PRODUCTCATEGORY_MAIN", "main.html", true, false, this.appSettings.API_ENDPOINTS.productcategories,
                "", this.loggingService, this.dataService, this.identityService, Meevo.Model.NounEnum.ProductCategoryMain, null, this.securityKeys.DATA_PRODUCTCATEGORY_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ));
    }

    initializeHeader(model:any): void {
        this.headerContent = model.displayName;
        this.businessTypeDetail = model.businessTypeDetail;
    }

    postCopy(): void {
        super.postCopy();
        let model = this.castModel<Model.ProductCategory>();
        model.displayName = undefined;
        model.subCategories.forEach(c=> c.id = Guid.newSqlSequentialGuid().toString());

    }
        
    addNewSubCat(): void {
        this["selectedSection"].model["subCategories"].push({
            displayName: "Sub Category " + (this["selectedSection"].model["subCategories"].length+1),
            backgroundColor: "#000000",
            id: Guid.newSqlSequentialGuid()["guid"]
        });
    }

  }
}